new Vue({
    el:'#download',
    data(){
        return{
            search_index:0,
            iconArr:[
                'https://cdn.shopifycdn.net/s/files/1/0502/8033/3505/files/white.svg?v=1701048732',
                'https://cdn.shopifycdn.net/s/files/1/0502/8033/3505/files/red.svg?v=1701049713'
            ],
            search_text:'',
            search_tip:false,
            data:[
                {
                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/NeXLIM_2_1.avif?v=1782213096',
                    title:'NeXLIM 2',
                    url:'https://drive.google.com/drive/folders/12Swm7htuBlgVwZZOChIufdzhtulb-MHF'
                },
                {
                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/NeXLIM_2_MINI.avif?v=1782444338',
                    title:'NeXLIM 2 MINI',
                    url:'https://drive.google.com/drive/folders/1xEGKKNcQvGuT01eFFFqTOHJl8smCyuyx'
                },
                {
                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/UNIONE.avif?v=1778635492',
                    title:'UNIONE',
                    url:'https://drive.google.com/drive/u/1/folders/1rF3J8Ivpa_ipZ8wV7wKbVyhGICmVmvoN'
                },
                {
                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/XLIM_GO_LITE_1a1f15cd-3786-4472-8926-24f208f7a4b0.avif?v=1780020602',
                    title:'XLIM GO LITE',
                    url:'https://drive.google.com/drive/folders/1KrBGLKcjqS1hjDbJFsBqO_yHXTkHNUhJ'
                },
                {
                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Slimstick_X.avif?v=1770632169',
                    title:'SLIMSTICK X',
                    url:'https://drive.google.com/drive/folders/1mgui8gAu5c_QbyVlhrEEjsoqQbGqddM0'
                },
                {
                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/XLIM_PRO_3_NC.avif?v=1787040780',
                    title:'XLIM PRO 3',
                    url:'https://drive.google.com/drive/folders/1A4khswk2L20kCgtUwJMoqd908CA1qhKy'
                },
                {
                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/XLIM_3_ULTRA_new_awards.avif?v=1786349042',
                    title:'XLIM 3 ULTRA',
                    url:'https://drive.google.com/drive/folders/1vZBvvSs6Wgjk9GSXHm9am9zhAN-PT8mI'
                },
                {
                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/XLIM_GO_2_NC_089ebe70-d00a-43f2-bee3-d1a9b5f57b8e.avif?v=1787040781',
                    title:'XLIM GO 2',
                    url:'https://drive.google.com/drive/folders/1Tfb0kntkv6qyd_NQd15gx1Z97g98-uNb'
                },
                {
                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/SLIMSTICK_awards.avif?v=1767754813',
                    title:'SLIMSTICK',
                    url:'https://drive.google.com/drive/folders/1x96JFhzcX4PvBdPBme4FIDkOe2fFl2Ml'
                },
                {
                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/ARTIO_2.avif?v=1765942847',
                    title:'ARTIO 2',
                    url:'https://drive.google.com/drive/folders/1j8WlSo7ZsFMfKtSPgpG-Q3Vn0oXm6iDx'
                },
                {
                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/NeXLIM_GO_c837eb9c-ecde-42dd-83c1-32e231b36206.avif?v=1770632350',
                    title:'NeXLIM GO',
                    url:'https://drive.google.com/drive/folders/1dWQwxTkYyHpBTh8J3aWrWA71cyb9B_hq'
                },
                {
                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/XLIM_PRO_2_DNA_2cb4e5e8-d2e8-443b-a7ca-7532f81efb14.avif?v=1770632350',
                    title:'XLIM PRO 2 DNA Version',
                    url:'https://drive.google.com/drive/folders/10tF2nLOlxEu9ujhNC5WGZYi7QUKG30_B'
                },
                {
                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/XLIM_SQ_PRO_2_4c8378d1-d1bd-49a5-a4e2-8883b1494833.avif?v=1765938621',
                    title:'XLIM SQ PRO 2',
                    url:'https://drive.google.com/drive/folders/18_ePiMNtLsZw3BDjGy2fJJzju9UkhnCE'
                },
                {
                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/NeXLIM_84119bc5-30f2-428b-87fa-b103204e6944.avif?v=1765942847',
                    title:'NeXLIM',
                    url:'https://drive.google.com/drive/folders/1WjYpS1LpbbtmytHT7irTRXw1FFGj5syv'
                },
                {
                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/VPRIME_2d17c000-c575-44b2-990a-5054170d87fb.avif?v=1765943503',
                    title:'VPRIME',
                    url:'https://drive.google.com/drive/folders/1yoJAtGYFvvmYkdCjssDv4jxwTqGK52cl'
                },
                {
                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/XLIM_PRO_2_3ba51614-1c11-4cca-bfa3-86812fb2ef97.avif?v=1765938621',
                    title:'XLIM PRO 2',
                    url:'https://drive.google.com/drive/folders/1CuP2JW5f_9_og-kOxAuRG3T2o51hlMPa'
                },
                {
                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/XLIM_CLASSIC_EDITION.avif?v=1765938621',
                    title:'XLIM CLASSIC EDITION',
                    url:'https://drive.google.com/drive/folders/1vcXDGVjd7FVmt8tRegu_aEuys351v74k'
                },
                {
                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/XLIM_GO_d5b55962-0828-4559-9b88-a582106621e0.avif?v=1765938621',
                    title:'XLIM GO',
                    url:'https://drive.google.com/drive/folders/1W9U3Bcu1CPjYXnQ7xVUztAlSn-q3YtWO'
                },
                {
                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/XLIM_SE_2.avif?v=1765938621',
                    title:'XLIM SE 2',
                    url:'https://drive.google.com/drive/folders/1vnPdXzlOF2vTu0AKTIiPiqVycByOVFk2'
                },
                {
                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/XLIM_SQ_PRO_0d8f254c-3e89-408f-9608-024b883b2d54.avif?v=1765938621',
                    title:'XLIM SQ PRO',
                    url:'https://drive.google.com/drive/folders/1cq8sCeT8ErO3cGONPnaG7mRkkcIhOtEK'
                },
                {
                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/ONEO_2b08f54a-b4d9-43d3-b774-a245005dedfe.avif?v=1765942848',
                    title:'ONEO',
                    url:'https://drive.google.com/drive/folders/1KI0YthwFkSgu9X81soKtB3K7J3yGYwot'
                },
                {
                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/XLIM_PRO_6258af78-380b-4c47-ab42-ea780094ae66.avif?v=1765938621',
                    title:'XLIM PRO',
                    url:'https://drive.google.com/drive/folders/1qHh1E19LGHjicA9KpAbG-i2GJdXQAcr7'
                },
                {
                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/XLIM_TOP_FILL_CARTRIDGE_3ML.avif?v=1765951670',
                    title:'XLIM TOP FILL CARTRIDGE',
                    url:'https://drive.google.com/drive/folders/1DSyajgm0XlN_Mx3a-7xeKz_56_Inh1Zj'
                },
                {
                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/XLIM_EZ_CARTRIDGE.avif?v=1765951670',
                    title:'XLIM EZ CARTRIDGE',
                    url:'https://drive.google.com/drive/folders/1_8_LaEb0uv7h8Xf8FuacXu9zfL9UbXmI'
                },
                {
                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/XLIM_POD.avif?v=1765938621',
                    title:'XLIM POD',
                    url:'https://drive.google.com/drive/folders/1zWrz1oA7thppTkTqCZMP1BmHtsOEjJue'
                },
                {
                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/XLIM_SE.avif?v=1765938621',
                    title:'XLIM SE',
                    url:'https://drive.google.com/drive/folders/1gk8_8avJYM_wff8KLwaK5txuDKduQpAL'
                },
                {
                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/XLIM_SQ.avif?v=1765938621',
                    title:'XLIM SQ',
                    url:'https://drive.google.com/drive/folders/1dgiUxr-CYGRjkHKdHhdZc4uarW5VFU1R'
                },
                {
                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/XLIM_C.avif?v=1765938621',
                    title:'XLIM C',
                    url:'https://drive.google.com/drive/folders/1Il4CYXUwqjwbtTQ8O7iiuUCfjtV4ZU9K'
                },
                {
                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/VELOCITY_LE.avif?v=1765943503',
                    title:'VELOCITY LE',
                    url:'https://drive.google.com/drive/folders/14HQsZUoGl_vCxN-jDlIzS21hu3HJa7Uo'
                },
                {
                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/ORIGIN_SE.avif?v=1765943503',
                    title:'ORIGIN SE',
                    url:'https://drive.google.com/drive/folders/1EmGI3End1UCAy8EczEqhkgZQulKdoWtm'
                },
                {
                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/ORIGIN_2.avif?v=1765943503',
                    title:'ORIGIN 2',
                    url:'https://drive.google.com/drive/folders/1kDsmK8_PGS-Z22p3b3GQdwabGZPV5D1z'
                },
                {
                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/ORIGIN_MINI.avif?v=1765943503',
                    title:'ORIGIN MINI',
                    url:'https://drive.google.com/drive/folders/1HqNOIhkJulMdI9v-zFSMnwvzbcNhn2-Z'
                },
                {
                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/arbiter-2.avif?v=1765943503',
                    title:'ARBITER 2',
                    url:'https://drive.google.com/drive/folders/15I109d7K41kxPxLUVinucqGc6Z6X1foR'
                },
                {
                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/arbiter-rta.avif?v=1765943503',
                    title:'ARBITER RTA',
                    url:'https://drive.google.com/drive/folders/1N5SxTZJTZcTSBKPoH8D3PRRHuVJlm9Pl'
                },
                {
                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/ORIGIN_X.avif?v=1765943503',
                    title:'ORIGIN X',
                    url:'https://drive.google.com/drive/folders/1dcnWZPwM1ozrkDET_-oo15077lUrfvIt'
                }
            ]
        }
    },
    methods:{
        searchBlur(){
            setTimeout(() => {
                this.search_tip=false 
            }, 150);
        },
        submitI(e){
            if(e.keyCode == 13){
                this.downloadSearch()
            }
        },
        downloadSearch(id,text){
            if(id==1){
                this.search_text = text
            }
            var down_flag = true
            var vStr1 = this.search_text.toLowerCase();
            var vStr2 = $.trim(vStr1);
            var vStr = vStr2.replace(/\s*/g,"");
            for(var y=0;y<$('.dli_item').length;y++){
                var text = $('.dli_item')[y].children[0].children[1].innerHTML
                var str1 = text.toLowerCase();
                var str2 = $.trim(str1);
                var str = str2.replace(/\s*/g,"");
                if(str.search(vStr) != -1){
                    $('.dli_item')[y].style.display = 'block';
                    down_flag = false;
                }else{
                    $('.dli_item')[y].style.display = 'none';
                }
            }
            
            this.search_tip=false
        
            //search of no result
            if(down_flag){
                this.search_text = ''
                $('.dli_item').show()
            }
        }
    }
})